import {
  apiGet,
  getCurrentUserId,
  apiPost,
  apiPut,
  getCurrentUserOrganizationId,
  apiDelete,
  apiPatch,
} from "../../../utils";

export const clientQueryUserAPI = (data = {}) => {
  return apiGet("/api/clientQuery", { ...data });
};

export const clientQueryOrgAPI = (mdata) => {
  const organizationId = getCurrentUserOrganizationId();
  let data = { ...mdata, organizationId: organizationId };

  return apiGet("/api/clientQuery", { ...data });
};

export const getAddressDetailsAPI = (query) => {
  let data = { ...query, userId: getCurrentUserId() };
  return apiGet("/api/addressbook/getAddressDetails", data);
};

export const getSingleAddressDetailsAPI = (query) => {
  let data = { ...query };
  return apiGet("/api/addressbook/getSingleAddressDetails", data);
};

export const addAddressDetailsAPI = (data) => {
  return apiPost("/api/addressbook/addAddressDetails", data);
};

export const updateAddressDetailsAPI = (data) => {
  return apiPost("/api/addressbook/updateAddressDetails", data);
};

export const deleteAddressDetailsAPI = (id) => {
  return apiDelete(`/api/addressbook/${id}`);
};

export const getVesselIndexesAPI = (data) => {
  return apiGet('/api/vesselIndexes', data);
};

export const addIndexDetailsAPI = (data) => {
  return apiPost('/api/vesselIndexes', data);
};

export const getIndexListAPI = () => {
  return apiGet('/api/vesselIndexes/vesselIndex-list');
};

export const getMyIndexListAPI = (data) => {
  return apiGet('/api/vesselIndexes/my-vesselIndex-list', data);
};

export const updateIndexDetailsAPI = (params, data) => {
  return apiPatch(`/api/vesselIndexes/${params}`, data)
};

export const addIndexDataAPI = (data) => {
  return apiPatch(`/api/vesselIndexes/add-index-data`, data)
};